import { AirlineCode, LocalDateTime, Amount } from "../../common";
import {
  Prices,
  PostQuoteAncillariesEnum,
  RewardsPrice,
  SeatMapCallback,
} from "./payment-machine";

export interface GetSeatMapRequest {
  callback: SeatMapCallback;
}

export interface GetSeatMapResponse {
  html: string;
  cheapestSeat: Prices;
}

export interface GordianPriceObject {
  base_price: number;
  decimal_places: number;
  markup_amount: number;
  usd_total: number;
  total: number;
  currency: string;
  usd_markup_amount: number;
  usd_base_price: number;
}

export interface HopperPriceObject {
  amount: number;
  amountUsd: number;
  currency: string;
  decimalPlaces: number;
  display: string;
  mantissa: number;
  mantissaUsd: number;
}

export interface GordianSeat {
  seat_id: string;
  product_id: string;
  unique_id: number;
  agent_id: string;
  pax_id: string;
  pax: string;
  person_id: string;
  price: string;
  display_name: string;
  flight_string: string;
  session_id: number;
  currency: string;
  carrier: string;
  product_type: FulfillAncillaryType;
  price_object: GordianPriceObject;
  rewards: { [key: string]: RewardsPrice };
}

export interface HopperSeat extends Omit<GordianSeat, "price_object"> {
  price_object: HopperPriceObject;
}

export type FulfillAncillaryType = bag | seat;

export interface bag {
  FulfillAncillaryType: FulfillAncillaryTypeEnum;
}

export interface seat {
  FulfillAncillaryType: FulfillAncillaryTypeEnum;
}

export enum FulfillAncillaryTypeEnum {
  bag = "bag",
  seat = "seat",
}

export interface Seats {
  seats: SelectSeatsCommand;
  PostQuoteAncillaries: PostQuoteAncillariesEnum;
}

export interface SelectSeatsCommand {
  seats: GordianSeat[];
}
export interface SeatPrice {
  amount: number;
  amountUsd: number;
  currency: string;
  decimalPlaces: number;
  display: string;
  mantissa: number;
  mantissaUsd: number;
}
export interface SeatInfo {
  carrier: string;
  display_name: string;
  pax: string;
  pax_id: string;
  person_id: string;
  seat_id: string;
  total: SeatPrice;
}
export interface SeatSegment {
  departureDate: string;
  destinationCode: string;
  originCode: string;
  seats: SeatInfo[];
}

export interface ItinerarySeats {
  seats: FortWorthSeat[];
  pricingInfo?: SeatsPricingInfo;
  paxPricing?: { [passengerId: string]: FortWorthSeat };
}
export interface SeatsPricingInfo {
  amount: Amount;
  id: string;
}
export interface FortWorthSeat {
  passengerId: { value: string };
  personId: string;
  seatId: { value: string };
  productId: { value: string };
  id: { value: number };
  displayString: string;
  price: number;
  currency: string;
  carrier: AirlineCode;
  outgoing: boolean;
  purchaseId: string;
  origin: string;
  destination: string;
  markupPrice?: number;
  departureTime?: LocalDateTime;
  arrivalTime?: LocalDateTime;
  airlinePnr?: string;
}
export interface SelectedSeatsSegment {
  originCode: string;
  flightNumber: string;
  seats: SeatSegment;
  isOutgoing?: boolean;
  idx: number;
}
